export default "__VITE_ASSET__99f20803__"